/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import clearIcon from 'Assets/images/commons/search_clear.svg';
import { CurrencyLabel } from 'Modules/Currency';
import Space from 'Modules/Space';
import {
  getLifepackMedicine,
  searchLifepackProducts,
} from 'Redux/modules/webChat/prescription/actions';
import classNames from 'classnames';
import { debounce } from 'lodash';
import { func, shape, string } from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Search } from 'semantic-ui-react';

import styles from './MedicinePickerField.less';

const PAGE_SIZE_SEARCH_MEDICINE = 30;

const ResultRenderer = ({ name, id, currencySymbol, unitPrice, product }) => {
  const isAvailable = !!product.stockAvailability;

  return (
    <div className={styles.searchResults} key={id}>
      <div style={{ flex: 30 }}>
        <div style={{ marginBottom: '0.5rem' }}>{name}</div>
        <Space direction="horizontal" alignItems="center" size={4}>
          <div className={styles.note}>Product code: {product.id || ''}</div>
          <div>-</div>
          <div className={classNames(styles.stock, { [styles.outOfStock]: !isAvailable })}>
            {isAvailable ? 'Available' : 'Out of stock'}
          </div>
        </Space>
      </div>
      <div style={{ flex: 6, textAlign: 'right' }}>
        <strong>
          {currencySymbol} <CurrencyLabel value={unitPrice} />
        </strong>
      </div>
    </div>
  );
};

ResultRenderer.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  unitPrice: string.isRequired,
  currencySymbol: string.isRequired,
};

const transform = (arr, currencySymbol) => {
  if (!arr?.length) return [];

  return arr.map(item => ({
    id: item.id,
    name: item.name,
    unitPrice: item.price,
    unitPriceBeforeTax: item.price,
    uom: item.uom,
    uomCode: item.uomCode,
    Dosage: '',
    quantity: 1,
    currencySymbol,
    product: item,
  }));
};

const MedicinePickerField = props => {
  const {
    field: { name, value },
    form: { setFieldValue, values },
    label,
    resultSearchChange,
    currencySymbol,
  } = props;
  const [currentValue, setCurrentValue] = useState('');

  const dispatch = useDispatch();

  const {
    searchLifepackProducts: results,
    status: { searchLifepackProducts: statusSearch },
  } = useSelector(state => state.webChat.prescription);

  useEffect(() => {
    if (value) {
      setCurrentValue(value.name);
    }
  }, [value]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (values.mode === 'edit' && values.lifepackProductId && !value.product) {
        const data = await dispatch(getLifepackMedicine(values.lifepackProductId));
        setFieldValue(name, {
          ...value,
          product: data.data,
        });
      }
    };
    fetchProducts();
  }, [dispatch, name, setFieldValue, value, values, values.mode, values.lifepackProductId]);

  const handleResultSelect = (e, { result }) => {
    setCurrentValue(result.name);
    setFieldValue(name, result);

    const defaultQuantity = result?.product.defaultQty ?? 1;

    const dosageInstruction = result?.product?.dosageInstruction;

    const defaultAmountPerTime = dosageInstruction?.dosage;
    const defaultDoseCode = dosageInstruction?.doseUnit;
    const defaultRouteCode = result?.product?.route;
    const defaultFrequencyCode = dosageInstruction?.frequency;
    const defaultDuration = dosageInstruction?.duration;
    const defaultDurationUnitCode = dosageInstruction?.durationUnit;
    const defaultNote = dosageInstruction?.timing ?? '';

    setFieldValue('quantity', defaultQuantity);
    setFieldValue('lifepackProductId', result.id);
    setFieldValue('uomUnit', result.uom);
    setFieldValue('uomCode', result.uomCode);

    setFieldValue('amountPerTime', defaultAmountPerTime);
    setFieldValue('doseUnitCode', defaultDoseCode);
    setFieldValue('routeCode', defaultRouteCode);
    setFieldValue('frequencyCode', defaultFrequencyCode);
    setFieldValue('duration', defaultDuration);
    setFieldValue('durationUnitCode', defaultDurationUnitCode);
    setFieldValue('note', defaultNote);
  };

  useEffect(() => {
    resultSearchChange(results, currentValue);
  }, [currentValue, resultSearchChange, results]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearchProduct = useCallback(
    debounce(val => {
      if (val)
        dispatch(
          searchLifepackProducts({
            searchTerm: val,
            page: 1,
            pageSize: PAGE_SIZE_SEARCH_MEDICINE,
          }),
        );
    }, 300),
    [],
  );

  const handleSearchChange = async (e, { value: val }) => {
    setCurrentValue(val);
    handleSearchProduct(val);
  };

  const clearSearch = () => {
    setCurrentValue('');
    setFieldValue(name, '');
  };

  return (
    <Form.Field className={styles.field}>
      <label htmlFor={name} className={styles.label}>
        {label}
      </label>

      <Search
        fluid
        loading={statusSearch === 0}
        onResultSelect={handleResultSelect}
        onSearchChange={handleSearchChange}
        results={transform(results, currencySymbol)}
        value={currentValue}
        currencySymbol={currencySymbol}
        resultRenderer={renderProps => (
          <ResultRenderer {...renderProps} currencySymbol={currencySymbol} />
        )}
        placeholder="Search medicine"
        noResultsMessage=""
        input={{
          icon: 'search',
          iconPosition: 'left',
          action: (
            <button className={styles.clearSearch} type="button" onClick={clearSearch}>
              <img src={clearIcon} alt="clear" />
            </button>
          ),
          actionPosition: 'right',
        }}
      />
    </Form.Field>
  );
};

MedicinePickerField.propTypes = {
  field: shape({}).isRequired,
  resultSearchChange: shape({}).isRequired,
  form: shape({
    setFieldValue: func.isRequired,
    touched: shape({}).isRequired,
  }).isRequired,
  label: string.isRequired,
  pharmacyId: string.isRequired,
  currencySymbol: string.isRequired,
};

export default MedicinePickerField;
